<template>
  <div>
    <div :class="`${node.type == 'group' ? 'node-hover' : ''}`">
      <div
          :style="{'margin-left': 25 * depth + 'px'}"
      >
        <div class="d-flex justify-content-between">
          <div class="node" @click="getGroupData(node.id)">
            <span v-if="node.type == 'group'">{{ expanded ? '&#9660' : '&#9658' }}</span>
            <span v-if="node.type == 'group'">{{ node.name }}</span>
          </div>
          <div v-if="type == 'group'" class="d-flex">
            <div class="dropdown w-30">
              <button type="button" class="w-44 btn btn-sm dropdown-toggle py-0" data-bs-toggle="dropdown">
                <img src="/app-assets/images/icons/plus-solid.svg" alt="">
              </button>
              <div class="dropdown-menu dropdown-menu-end">
                <a @click.prevent="onClickAddGroupBtn" v-if="depth < 2" class="dropdown-item" href="#">
                  <span>Add sub Group</span>
                </a>
                <a @click.prevent="onClickAddResourceBtn(node)" class="dropdown-item" href="#">
                  <span>Add Resource</span>
                </a>
              </div>
            </div>
            <div class="w-20 z-999"></div>
            <div>
              <img
                  @click="emitGroupEdit"
                  width="13"
                  class="cursor-pointer"
                  src="/app-assets/images/icons/pencil-alt-solid.svg"
                  alt=""
              >
            </div>
          </div>
        </div>
        <div
            class="d-flex cursor-initial justify-content-between bg-black-light rounded-8 p-1 mb-1"
            v-if="node.type == 'endpoint'"
        >
          <p class="mb-0">{{ node.name }}</p>
          <div class="d-flex">
            <span class="badge badge-light-dark font-small-3">{{ node.service_general_status }}</span>
            <p class="mb-0 me-1">{{ node.total }}</p>
            <img @click="emitResourceEdit" width="13" class="cursor-pointer"
                 src="/app-assets/images/icons/pencil-alt-solid.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <hr class="mb-1 mt-0" v-if="type == 'group'">
    <template v-if="expanded">
      <TreeBrowser
          v-for="item in childServiceResource"
          :key="item.name"
          :parent="node"
          :depth="depth + 1"
          :node="item"
      />
    </template>

    <Loader v-if="loading"/>

  </div>
</template>

<script setup>
import {computed, defineEmits, inject, ref, watch} from "vue";
import TreeBrowser from '@/components/molecule/company/hospital/service-resources/ServiceResourceTree'
import handleHospital from '@/services/modules/hospital'
import {useRoute} from "vue-router";
import Loader from '@/components/atom/LoaderComponent'

const props = defineProps({
  node: Object,
  depth: {
    type: Number,
    default: 0
  },
  parent: {
    default: []
  },
  offset:{
    default:20,
  }
})
const route = useRoute()
const loading = ref(false)
const emitter = inject('emitter');
const expanded = ref(false)
const groupId = ref(null);
const type = computed(() => props.node.type)
const {
  fetchServiceResourceChild
} = handleHospital()
const companyId = computed(() => route.params.companyId);
const accountType = computed(() => route.params.accountType);
const childServiceResource = ref([]);

const onClickAddGroupBtn = () => {
  emitter.emit('onClickAddGroup', props.node)
}

const emitGroupEdit = () => {
  emitter.emit('onUpdateGroup', {
    eventName: 'onUpdateGroup',
    title: 'Edit group',
    data: props.node
  })
}

watch(accountType , () => {
  expanded.value = false
})

const onClickAddResourceBtn = (data) => {
  emitter.emit('onClickAddResource', data)
}

const getGroupData = async(id) => {
  if(expanded.value && id == groupId.value) {
    expanded.value = !expanded.value
    return
  }

  groupId.value = id;
  expanded.value = true;
  await fetchData(groupId.value)
}

const fetchData = async (groupId) => {
  let query = `?company_id=${companyId.value}&resource_type=${accountType.value}`

  try {
    loading.value = true
    let res = await fetchServiceResourceChild(groupId, query)
    if (!res.status) {
      return;
    }
    childServiceResource.value = res.data.child
  } catch (err) {
    console.log(err)
  } finally {
    loading.value = false
  }
}

const emitResourceEdit = () => {
  emitter.emit('onUpdateResource', {
    eventName: 'onUpdateLocation',
    title: 'Edit resource',
    data: props.node
  })
}
</script>

<style scoped>
.bg-black-light {
  background: #00000024;
}

.rounded-8 {
  border-radius: 8px;
}

.node {
  cursor: pointer;
}

.node-hover {
  padding: 10px 2px;
}

.node-hover:hover {
  background: #fffeec;
}

.cursor-initial {
  cursor: initial;
}

.cursor-pointer {
  cursor: pointer;
}

.w-30 {
  width: 30px;
}

.w-20 {
  width: 20px;
}

.z-999 {
  z-index: 999;
}

.w-44 {
  width: 44px;
}
</style>
